module.exports = __webpack_public_path__ + "img/curved6.fbe8fb52.jpg";